// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ComponentMgrOutlinedSvg from "@fishx/icons-svg/es/asn/ComponentMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var ComponentMgrOutlined = function ComponentMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ComponentMgrOutlinedSvg
  }));
};

ComponentMgrOutlined.displayName = 'ComponentMgrOutlined';
export default React.forwardRef(ComponentMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ComponentMgrOutlined.js
// module id = 2295
// module chunks = 0